<template>
  <div>
    <yjh-header :activeIndex="idnex"></yjh-header>
    <div class="about_us">
      <div class="navBox">
        <div class="w">
          <yjh-sNav :titleList="titleArr" @myFn="navRoute"></yjh-sNav>
        </div>
      </div>
      <yjh-jtjg v-if="navIndex == 0"></yjh-jtjg>
      <yjh-gltd v-if="navIndex == 1"></yjh-gltd>
      <yjh-qyry v-if="navIndex == 2"></yjh-qyry>
    </div>
    <div class="about_us_mobile">
      <div class="nav_mobile">
        <div class="navItem" :class="{ active: 0 == mobileNavIndex }" @click="navClick_0">
          <div class="icon">
            <i class="iconfont iconjiagou"></i>
          </div>
          <div class="nav_title">公司架构</div>
        </div>
        <div class="navItem" :class="{ active: 1 == mobileNavIndex }" @click="navClick_1">
          <div class="icon">
            <i class="iconfont icontuandui"></i>
          </div>
          <div class="nav_title">管理团队</div>
        </div>
        <div class="navItem" :class="{ active: 2 == mobileNavIndex }" @click="navClick_2">
          <div class="icon">
            <i class="iconfont iconqiyerongyu"></i>
          </div>
          <div class="nav_title">企业荣誉</div>
        </div>
      </div>
      <yjh-jtjg v-if="mobileNavIndex == 0"></yjh-jtjg>
      <yjh-gltd v-if="mobileNavIndex == 1"></yjh-gltd>
      <yjh-qyry v-if="mobileNavIndex == 2"></yjh-qyry>
    </div>
    <yjh-footer></yjh-footer>
  </div>
</template>

<script>
import footer from "@/layouts/footer";
import header from "@/layouts/header";
import sNav from "@/layouts/sNav";
import gltd from "./component/gltd";
import jtjg from "./component/jtjg";
import qyry from "./component/qyry";
export default {
  components: {
    "yjh-footer": footer,
    "yjh-header": header,
    "yjh-sNav": sNav,
    "yjh-gltd": gltd,
    "yjh-jtjg": jtjg,
    "yjh-qyry": qyry,
  },
  props: ["sNav", "header"],
  data() {
    return {
      idnex: "2",
      titleArr: [
        {
          id: 0,
          status: true,
          title: "公司架构",
          sTitle: "Group architecture",
        },
        {
          id: 1,
          status: false,
          title: "管理团队",
          sTitle: "corporate culture",
        },
        {
          id: 2,
          status: false,
          title: "企业荣誉",
          sTitle: "enterprise honor",
        },
      ],
      navIndex: "0",
      mobileNavIndex: "0",
    };
  },
  created() {
    if (this.$route.query.navIndex == undefined) {
      this.navClick("0");
    } else {
      this.navClick(this.$route.query.navIndex);
    }
  },
  methods: {
    navClick_2() {
      this.mobileNavIndex = 2;
    },
    navClick_1() {
      this.mobileNavIndex = 1;
    },
    navClick_0() {
      this.mobileNavIndex = 0;
    },
    // 导航栏切换
    navClick(id) {
      this.navIndex = id;
      for (let i = 0; i < this.titleArr.length; i++) {
        this.titleArr[i].status = false;
      }
      this.titleArr[id].status = true;
    },
    // 导航栏路由
    navRoute(id) {
      this.$router.push({
        path: "/aboutUs",
        query: {
          navIndex: id,
        },
      });
      this.navClick(id);
    },
  },
};
</script>

<style lang="less">
.title {
  margin-top: 30px;
  font-size: 30px;
}
@media screen and (max-width: 999px) {
  .about_us {
    display: none;
  }
  .about_us_mobile {
    .nav_mobile {
      display: flex;
      justify-content: space-around;
      .navItem {
        text-align: center;
        .icon {
          margin: 10px 0;
          .iconfont {
            font-size: 24px;
          }
        }
        .nav_title {
          margin-bottom: 10px;
        }
      }
      .active {
        color: #da261d;
      }
    }
  }
}
@media screen and (min-width: 1000px) {
  .about_us_mobile {
    display: none;
  }
}
</style>
